export default __webpack_public_path__ + "static/media/emptyCircle.b97a36c7.svg";